module.exports = __webpack_public_path__ + "static/media/user01.c66c16f0.jpg";